var _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPhoneProfileIllustration(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 400,
    height: 220,
    viewBox: "0 0 400 220",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4,
    filter: "url(#filter0_d_0_3)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57 27C49.8203 27 44 32.8203 44 40V141C44 148.18 49.8203 154 57 154H71V62C71 54.8203 76.8203 49 84 49H314V40C314 32.8203 308.18 27 301 27H57Z",
    fill: "#818CF8"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M314 49V141C314 148.18 308.18 154 301 154H71V62C71 54.8203 76.8203 49 84 49H314Z",
    fill: "#818CF8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M343 49H84C76.8203 49 71 54.8203 71 62V180C71 187.18 76.8203 193 84 193H343C350.18 193 356 187.18 356 180V62C356 54.8203 350.18 49 343 49Z",
    fill: "#818CF8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.53,
    d: "M71 62C71 54.8203 76.8203 49 84 49H343C350.18 49 356 54.8203 356 62V70H71V62Z",
    fill: "#F8FAFC"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M128 98C128 88.0589 119.941 80 110 80C100.059 80 92 88.0589 92 98C92 107.941 100.059 116 110 116C119.941 116 128 107.941 128 98Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M279.5 86H147.5C145.015 86 143 88.0147 143 90.5C143 92.9853 145.015 95 147.5 95H279.5C281.985 95 284 92.9853 284 90.5C284 88.0147 281.985 86 279.5 86Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.53,
    d: "M209.5 98H147.5C145.015 98 143 100.015 143 102.5C143 104.985 145.015 107 147.5 107H209.5C211.985 107 214 104.985 214 102.5C214 100.015 211.985 98 209.5 98Z",
    fill: "#F8FAFC"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.53,
    d: "M334.5 98H224.5C222.015 98 220 100.015 220 102.5C220 104.985 222.015 107 224.5 107H334.5C336.985 107 339 104.985 339 102.5C339 100.015 336.985 98 334.5 98Z",
    fill: "#F8FAFC"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M92 133C92 130.239 94.2386 128 97 128H165C167.761 128 170 130.239 170 133V193H92V133Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M175 133C175 130.239 177.239 128 180 128H247C249.761 128 252 130.239 252 133V193H175V133Z",
    fill: "white"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M257 133C257 130.239 259.239 128 262 128H330C332.761 128 335 130.239 335 133V193H257V133Z",
    fill: "white"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M88 64C90.2091 64 92 62.2091 92 60C92 57.7909 90.2091 56 88 56C85.7909 56 84 57.7909 84 60C84 62.2091 85.7909 64 88 64Z",
    fill: "#4F46E5"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M103 64C105.209 64 107 62.2091 107 60C107 57.7909 105.209 56 103 56C100.791 56 99 57.7909 99 60C99 62.2091 100.791 64 103 64Z",
    fill: "#F8FAFC"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M118 64C120.209 64 122 62.2091 122 60C122 57.7909 120.209 56 118 56C115.791 56 114 57.7909 114 60C114 62.2091 115.791 64 118 64Z",
    fill: "#F59E0B"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_0_3",
    x: 26,
    y: 16,
    width: 306,
    height: 163,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 7
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 9
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.537014 0 0 0 0 0.703924 0 0 0 0 0.870833 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_0_3"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_0_3",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneProfileIllustration);
export default __webpack_public_path__ + "static/media/phone_profile_illustration.7aeb67954f43450b641f52ae05c6b181.svg";
export { ForwardRef as ReactComponent };